import React from "react";
import "./style.scss";

type AxisLabelsProps = {
  yTopTitle: React.ReactNode;
  yCenterTitle: React.ReactNode;
  yBottomTitle: React.ReactNode;
  xLeftTitle: React.ReactNode;
  xCenterTitle: React.ReactNode;
  xRightTitle: React.ReactNode;
};

export const AxisLabels: React.FC<AxisLabelsProps> = ({
  yTopTitle,
  yCenterTitle,
  yBottomTitle,
  xLeftTitle,
  xCenterTitle,
  xRightTitle,
}) => {
  return (
    <div className="quadrant-axis-labels">
      <div className="y-labels">
        <div className="axis-label y-label start">{yTopTitle}</div>
        <div className="axis-label y-label center">{yCenterTitle}</div>
        <div className="axis-label y-label end">{yBottomTitle}</div>
      </div>
      <div className="x-labels">
        <div className="axis-label x-label start">{xLeftTitle}</div>
        <div className="axis-label x-label center">{xCenterTitle}</div>
        <div className="axis-label x-label end">{xRightTitle}</div>
      </div>
    </div>
  );
};

export default AxisLabels;
